"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletMaker = exports.safeFromAddr = exports.voidMasterCopy = void 0;
const ethers_1 = require("ethers");
const ethers_contracts_1 = require("../types/ethers-contracts");
const void_1 = require("./void");
const PROXY_ADDR = '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B';
const MASTER_COPY_ADDR = '0x6851D6fDFAfD08c0295C392436245E5bc78B0185';
const DEFAULT_HANDLER = '0xd5D82B6aDDc9027B22dCA772Aa68D5d74cdBdF44';
exports.voidMasterCopy = new ethers_contracts_1.GnosisSafe__factory(void_1.voidSigner).attach(void_1.addr0);
function safeFromAddr(signer, safeAddr) {
    return (new ethers_contracts_1.GnosisSafe__factory(signer)).attach(safeAddr);
}
exports.safeFromAddr = safeFromAddr;
async function setupDataForUser(user) {
    const setupData = await exports.voidMasterCopy.populateTransaction.setup([user], 1, void_1.addr0, '0x', DEFAULT_HANDLER, void_1.addr0, 0, void_1.addr0);
    if (!setupData.data) {
        throw new Error("no setup data");
    }
    return setupData.data;
}
class WalletMaker {
    constructor({ signer, chainId }) {
        this.signer = signer;
        const proxyFactory = new ethers_contracts_1.GnosisSafeProxyFactory__factory(signer).attach(PROXY_ADDR);
        this.proxyFactory = proxyFactory;
        this.chainId = chainId;
    }
    async deployTx(user) {
        const setupData = await setupDataForUser(user);
        return this.proxyFactory.populateTransaction.createProxyWithNonce(MASTER_COPY_ADDR, setupData, this.chainId);
    }
    async deployWallet(user) {
        var _a;
        const setupData = await setupDataForUser(user);
        const walletTx = await this.proxyFactory.createProxyWithNonce(MASTER_COPY_ADDR, setupData, this.chainId);
        const walletReceipt = await walletTx.wait();
        return (_a = walletReceipt.events[0].args) === null || _a === void 0 ? void 0 : _a.proxy.toLowerCase();
    }
    async walletAddressForUser(user) {
        const setupData = await setupDataForUser(user);
        const salt = ethers_1.utils.keccak256(ethers_1.utils.solidityPack(['bytes', 'uint256'], [ethers_1.utils.keccak256(setupData), this.chainId]));
        const initCode = ethers_1.utils.solidityKeccak256(['bytes', 'bytes'], [await this.proxyFactory.proxyCreationCode(), ethers_1.utils.defaultAbiCoder.encode(['address'], [MASTER_COPY_ADDR])]);
        const addr = ethers_1.utils.getCreate2Address(this.proxyFactory.address, salt, initCode);
        return addr.toLowerCase();
    }
    async isDeployed(user) {
        const addr = await this.walletAddressForUser(user);
        const code = await this.signer.provider.getCode(addr);
        return code !== '0x';
    }
}
exports.WalletMaker = WalletMaker;
